<div class="container pixl-multi-combo-entity-search">
    <mat-form-field (click)="onClick()">
        <div class="notFields"></div>
            @if (label()) {
                <mat-label>{{ label() }}</mat-label>
            }
            <div class="fields">
                <input
                    class="input"
                    #myInput
                    matInput
                    [placeholder]="placeHolder()"
                    aria-label="Suchfeld für Optionen"
                    (input)="onInputChanged($event)"
                    [formControl]="inputControl"
                    (keyup)="onClick()"
                />
                <mat-select
                    #mySelect
                    [multiple]="true"
                    (selectionChange)="onOptionSelected($event)"
                    (openedChange)="onSelectOpened($event, mySelect)"
                    [formControl]="selectControl"
                >
                    @if (isLoading()) {
                        <mat-option disabled>
                        <em>Lade...</em>
                        </mat-option>
                    }

                    @if (!isLoading() && allVisibleOptions.length === 0) {
                        <mat-option disabled>
                        <em>Geben Sie einen Suchbegriff ein</em>
                        </mat-option>
                    }

                    @if (!isLoading()){
                        @if (withEmptyOption()) {
                            <mat-option [value]="''">---</mat-option>
                        }
                        @for (entry of allVisibleOptions; track entry.id) {
                            <mat-option [value]="entry">
                                {{ getDisplayValue(entry) }}
                            </mat-option>
                        }
                        @if (dataList().length > 0) {
                            @for (entry of dataList(); track entry) {
                                <mat-option [value]="entry.value">
                                    {{ entry.text }}
                                </mat-option>
                            }
                        }
                    }
                </mat-select>
            </div>
            <mat-icon matSuffix style="cursor: pointer">
                arrow_drop_down
            </mat-icon>
    </mat-form-field>
</div>